import { useQuery } from '@tanstack/react-query'
import { FinancialsGrowthRequestBody, FinancialsGrowthResponseData } from '../../Config/types'
import { fetchFinancialsGrowth } from '../../requests/api'
import useAuthenticatedFetch from '../../requests/requestAuthenticated'

export const GROWTH_QUERY_KEY = 'growth'

/**
 * Query hook for fetching financials growth data
 * 
 * @param requestBody - The request body containing symbols and periods
 * @param enabled - Whether the query should be enabled
 */
export const useGrowthQuery = (requestBody: FinancialsGrowthRequestBody | null, enabled = true) => {
  const { fetchWithAuth } = useAuthenticatedFetch()
  
  return useQuery<FinancialsGrowthResponseData>({
    queryKey: [GROWTH_QUERY_KEY, requestBody],
    queryFn: () => {
      if (!requestBody) {
        throw new Error('Request body is required')
      }
      return fetchFinancialsGrowth(requestBody, fetchWithAuth)
    },
    enabled: enabled && !!requestBody && requestBody.symbols.length > 0,
  })
}

export default useGrowthQuery
